import { createContext } from "react";

type CurrentStackableContextValue = {
  /** The type of the stackable */
  type: string | null;
  /** Removes the current stackable making it not visible */
  remove: () => void;
  /** Whether this stackable is the topmost focused stackable */
  isFocused: boolean;
};

const CurrentStackableContext = createContext<CurrentStackableContextValue>({
  remove: () => console.warn("Oh no! CurrentStackableContext.remove() is not bound"),
  type: null,
  isFocused: false,
});

export default CurrentStackableContext;
